import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import api from '../../../api';
import DataTable from './DataTable';
import RefreshTimer from './RefreshTimer';

const columns = [
    { key: 'EmployeeName', label: 'Name' },
    { key: 'JobNum', label: 'Job #', cellStyle: { fontWeight: 700, fontFamily: '"Courier New", monospace', fontSize: 14 } },
    { key: 'Operation', label: 'Operation' },
    { key: 'JobQty', label: 'Job Qty' },
    { key: 'PartNum', label: 'Part #' },
    { key: 'StartTime', label: 'Start Time' },
];

const WindingTab = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const res = await api.get('/display-board/winding');
            setData(res.data?.employees || []);
        } catch (err) {
            setError(err.response?.data?.error || err.message || 'Failed to load Winding data');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchData(); }, [fetchData]);

    return (
        <Card className="border-0 shadow-sm">
            <CardHeader className="border-bottom d-flex justify-content-between align-items-center py-3">
                <h6 className="mb-0 fw-semibold">
                    <i className="ri-loop-left-line me-2 text-info"></i>
                    Winding Department — Display Board
                </h6>
                <RefreshTimer onRefresh={fetchData} interval={60} />
            </CardHeader>
            <CardBody className="p-0">
                {error && (
                    <div className="alert alert-danger m-3 mb-0" role="alert">
                        <i className="ri-error-warning-line me-2"></i>{error}
                    </div>
                )}
                <DataTable
                        highlightKey="JobNum"  // Round DB-1 — green = active job
                    columns={columns}
                    rows={data}
                    loading={loading}
                    emptyMessage="No Winding employees clocked in today"
                />
            </CardBody>
        </Card>
    );
};

export default WindingTab;